import Reactotron from "reactotron-react-native";
import { QueryClientManager, reactotronReactQuery } from "reactotron-react-query";
import type { QueryClient } from "@tanstack/react-query";

let connected = false;

export function initReactotron(queryClient: QueryClient) {
  if (connected) return;

  const queryClientManager = new QueryClientManager({ queryClient });

  Reactotron.configure({ name: "A3S" })
    .useReactNative({
      networking: { ignoreUrls: /symbolicate|logs/ },
    })
    .use(reactotronReactQuery(queryClientManager))
    .connect();

  connected = true;
}
